import { Component, OnInit } from '@angular/core';
import { Localization } from "../enums/localization";

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss']
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  public readonly Localization = Localization;

  ngOnInit() {
  }

}
